module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro10yearslater-4@3x.jpg?2340a0e8";